import { IconNames } from "../components/Icons/styles/iconNames";
import {
  DocumentStages,
  DocumentStatus,
  PropostaProviders,
  Services,
  UserRoles,
} from "../graphql/__GENERATED__/types";
import { TFilter } from "./types";

export const dashboardDocumentFilters = () =>
  documentFilters().filter((filter) =>
    ["stage", "status"].includes(filter.name)
  );

export const cardDocumentStatusFilters = () =>
  documentFilters()
    .filter((filter) => filter.name === "status")
    .flatMap((filter) => filter.options);

export const getStatusIcon = (status: DocumentStatus) => {
  const statusIcon = documentFilters()
    .find((filter) => filter.label === "Status")
    ?.options.find((option) => option.filter?.status === status)?.iconName;
  return statusIcon;
};

const documentFilters = (): TFilter[] => [
  {
    label: "Etapa",
    value: [],
    urlParam: "etapa",
    name: "stage",
    selectMultiValueDisplay: "all",
    options: [
      {
        value: "cotacao",
        label: "Cotações",
        filter: {
          stage: DocumentStages.Simulation,
        },
      },
      {
        value: "proposta",
        label: "Propostas",
        filter: {
          stage: DocumentStages.Proposal,
        },
      },
      {
        value: "apolice",
        label: "Apólices",
        filter: {
          stage: DocumentStages.Policy,
        },
      },
      {
        value: "sinistro",
        label: "Sinistros",
        filter: {
          stage: DocumentStages.Claim,
        },
      },
    ],
  },
  {
    label: "Responsável",
    value: [],
    urlParam: "responsavel",
    name: "responsible",
    selectOptionDisplay: "avatar",
    selectMenuListDisplay: "buttons",
    selectMultiValueDisplay: "all",
    many2Many: {
      serviceName: Services.Users,
      domain: { role: UserRoles.Admin },
    },
    options: [
      {
        value: "nenhum",
        label: "Sem Responsável",
        filter: {
          responsableId: null,
        },
      },
    ],
  },
  {
    label: "Parceiro",
    value: [],
    urlParam: "parceiro",
    name: "originator",
    many2Many: {
      serviceName: Services.Users,
      domain: { role: UserRoles.Consultant },
    },
    options: [
      {
        value: "nenhum",
        label: "Sem parceiro",
        filter: {
          originatorId: null,
        },
      },
    ],
  },
  {
    label: "Status",
    value: [],
    urlParam: "status",
    name: "status",
    selectOptionDisplay: "icon",
    selectMenuListDisplay: "buttons",
    selectMultiValueDisplay: "all",
    options: [
      {
        value: "incompletas",
        label: "Incompletas",
        filter: {
          status: DocumentStatus.Incomplete,
        },
        iconName: IconNames.Incomplete,
      },
      {
        value: "pendentes",
        label: "Pendentes",
        filter: {
          status: DocumentStatus.Pending,
        },
        iconName: IconNames.Pending,
      },
      {
        value: "finalizadas",
        label: "Finalizadas",
        filter: {
          status: DocumentStatus.Done,
        },
        iconName: IconNames.Done,
      },
      {
        value: "enviadas",
        label: "Enviadas",
        filter: {
          status: DocumentStatus.Sent,
        },
        iconName: IconNames.Sent,
      },
      {
        value: "expiradas",
        label: "Expiradas",
        filter: {
          status: "expired",
        },
        iconName: IconNames.Expired,
      },
      {
        value: "vigentes",
        label: "Vigentes",
        filter: {
          status: DocumentStatus.Effective,
        },
        iconName: IconNames.Valid,
      },
      {
        value: "nao-vigentes",
        label: "Não Vigentes",
        filter: {
          status: DocumentStatus.NonEffective,
        },
        iconName: IconNames.Expired,
      },
      {
        value: "em analise",
        label: "Em Análise",
        filter: {
          status: DocumentStatus.UnderAnalysis,
        },
        iconName: IconNames.Done,
      },
      {
        value: "recusadas",
        label: "Recusadas",
        filter: {
          status: DocumentStatus.Rejected,
        },
        iconName: IconNames.Rejected,
      },
      {
        value: "arquivadas",
        label: "Arquivadas",
        filter: {
          archived: true,
        },
        iconName: IconNames.Archive,
      },
    ],
  },
  {
    label: "Seguradora",
    value: [],
    urlParam: "seguradora",
    name: "provider",
    options: Object.values(PropostaProviders).map((provider) => ({
      value: provider,
      label: provider.toUpperCase(),
      filter: {
        provider: provider,
      },
    })),
  },
  {
    label: "Cultura",
    value: [],
    urlParam: "cultura",
    name: "culture",
    options: [],
  },
];

export default documentFilters;
